import React, { useState } from "react";

import {
  OverlayTrigger,
  Popover,
  ListGroup,
  Button,
} from "react-bootstrap";

import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from "react-sortable-hoc";

import { useTranslation } from 'react-i18next'

import arrayMove from "array-move";

import classes from "./CustomSortablePopover.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CustomSortablePopover: React.FC<any> = (props) => {
  const { t } = useTranslation();
  const [items, setItems] = useState<ISortableItem[]>(props.items);

  React.useEffect(() => {
    setItems(props.items);
  }, [props.items])

  const onSortEnd = ({
    oldIndex,
    newIndex,
  }: {
    oldIndex: number;
    newIndex: number;
  }) => {
    if (props.firstItemDisabled && newIndex === 0) {
      newIndex = 1;
    }
    setItems(arrayMove(items, oldIndex, newIndex));
  };

  const SortableItem = SortableElement(
    ({ value, i }: { i: any; value: any }) => {
      const elementId = `${props.id}-${i}`;
      return (
        <ListGroup>
          <span>
            <div className={[classes.sortableCheckbox, "form-check", "mb-1"].join(" ")}>
              <input
                type="checkbox"
                id={elementId}
                data-index={i}
                onChange={({ target }) => {
                  const index = target.getAttribute("data-index");
                  if (index) {
                    setItems(
                      items.map((val: any, itemsIndex: number) => {
                        if (itemsIndex === parseInt(index)) {
                          val.enabled = !val.enabled;
                        }
                        return val;
                      })
                    );
                  }
                }}
                disabled={value.disabled?true:false}
                checked={items[i].enabled}
                className="form-check-input"
              />
              <label htmlFor={elementId} className={[classes.sortableLabel, "form-check-label"].join(" ")}>
                {value.label}
              </label>
              <DragHandle />
            </div>
          </span>
        </ListGroup>
      )
    }
  );

  const SortableList = SortableContainer(({ items: listItems }: { items: any }) => {
    return (
      <ListGroup
        className={classes.sortableCont}
      >
        {listItems.map((value: ISortableItem, index: any) => (
          <SortableItem
            key={`item-${value.name}`}
            i={index}
            index={index}
            value={value}
            disabled={props.firstItemDisabled && index === 0 ? true : false}
          />
        ))}
      </ListGroup>
    );
  });

  const DragHandle = SortableHandle(() => (
    <span className="float-right">
      <FontAwesomeIcon
        icon={["fas", "sort"]}
        className={classes.paginationChevron}
      />
    </span>
  ));

  const handleDefaultClick = () => {
    const newItems =items.map((value: ISortableItem) => {
      value.enabled = value.isDefault;
      return value;
    });

    function compare( a: ISortableItem, b:ISortableItem ) {
      if ( a.defaultOrder < b.defaultOrder ){
        return -1;
      }
      if ( a.defaultOrder > b.defaultOrder ){
        return 1;
      }
      return 0;
    }
    newItems.sort( compare );
    setItems(newItems);
  }

  const handleSelectAllClick = () => {
    const newItems = items.map((value: ISortableItem) => {
      value.enabled = true;
      return value;
    });
    setItems(newItems);
  }

  return (
    <>
      <OverlayTrigger
        trigger="click"
        rootClose
        key={props.id}
        onExited={() => props.onPopoverExited(items)}
        placement={props.placement}
        overlay={
          <Popover id={props.id} className={classes.customPopover}>
            <Popover.Content>
              <SortableList
                lockAxis="y"
                onSortEnd={onSortEnd}
                useDragHandle
                helperClass={classes.sortableHelper}
                items={items}
              ></SortableList>
              <div className="border-top">
                <div className="float-left mt-2 mb-2 d-flex w-50">
                  <Button size="sm" className={[classes.actionButton, "flex-fill", "mr-1"].join(" ")} variant="outline-primary" onClick={handleSelectAllClick}>
                    {t("select_all")}
                  </Button>
                </div>
                <div className="float-right mt-2 mb-2 d-flex w-50">
                  <Button size="sm" className={[classes.actionButton, "flex-fill", "ml-1"].join(" ")} variant="outline-primary" onClick={handleDefaultClick}>
                    {t("select_default")}
                  </Button>
                </div>
                {/* <ButtonToolbar className="justify-content-between mt-2">
                  <ButtonGroup className="mr-2">
                    <Button size="sm" variant="secondary" onClick={handleSelectAllClick}>
                      {t("select_all")}
                    </Button>
                  </ButtonGroup>
                  <ButtonGroup>
                    <Button size="sm" variant="secondary" onClick={handleDefaultClick}>
                      {t("select_default")}
                    </Button>
                  </ButtonGroup>
                </ButtonToolbar> */}
              </div>
            </Popover.Content>
          </Popover>
        }
      >
        {props.children}
      </OverlayTrigger>
    </>
  );
};

export interface ISortableItem {
  value: any;
  name: string;
  label: string;
  enabled: boolean;
  disabled?: boolean;
  isDefault: boolean;
  defaultOrder: number;
}

export default CustomSortablePopover;
